import icon from 'vue-svgicon';

icon.register({
    'bold/messages-bubble-typing-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 1.375C5.682 1.375.541 5.611.541 10.817A8.567 8.567 0 0 0 3.7 17.333L1.416 21.9a.5.5 0 0 0 .447.725.51.51 0 0 0 .211-.047L8.2 19.727a13.691 13.691 0 0 0 3.8.531c6.318 0 11.459-4.236 11.459-9.441S18.318 1.375 12 1.375zm-5.041 11a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm5.041-3a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm5 3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z"/>`,
    },
});
